import { api } from "@/lib/api";

export const loadScript = () => new Promise((res, rej) => {
  if (window.Razorpay) return res();
  const s = document.createElement("script");
  s.src = "https://checkout.razorpay.com/v1/checkout.js";
  s.onload = res;
  s.onerror = () => rej(new Error("Could not load Razorpay"));
  document.body.appendChild(s);
});

// UPI / QR payments sometimes never fire the checkout callback; ask our server (which asks Razorpay) every few seconds.
export function watchPayment(rz, payId, onPaid) {
  let stopped = false;
  const tick = async () => {
    if (stopped) return;
    try {
      const { status } = (await api.post(`/payments/${payId}/reconcile`)).data;
      if (status === "success" && !stopped) { stopped = true; clearInterval(t); try { rz.close(); } catch (e) { /* already closed */ } onPaid(); }
    } catch (e) { /* keep polling */ }
  };
  const t = setInterval(tick, 5000);
  setTimeout(() => { stopped = true; clearInterval(t); }, 20 * 60 * 1000);
  return { stop: () => { stopped = true; clearInterval(t); }, check: tick };
}

export async function checkOnce(payId) {
  try { return (await api.post(`/payments/${payId}/reconcile`)).data.status; } catch (e) { return "unknown"; }
}

export async function payWithRazorpaySubscription(sub, me, verifyPath, description) {
  await loadScript();
  return new Promise((resolve, reject) => {
    const rz = new window.Razorpay({
      key: sub.key_id, subscription_id: sub.rzp_subscription_id, name: "LaunchX360", description,
      image: `${window.location.origin}/logo.webp`, theme: { color: "#0B5D36" },
      prefill: { name: me.user.name, email: me.user.email, contact: me.user.phone || "" },
      handler: async (resp) => { try { resolve((await api.post(verifyPath, resp)).data); } catch (e) { reject(e); } },
      modal: { ondismiss: () => reject(new Error("Authorisation cancelled")) },
    });
    rz.on("payment.failed", (r) => reject(new Error(r.error?.description || "Authorisation failed")));
    rz.open();
  });
}

export async function payWithRazorpay(pay, me, verifyPath, description, refresh) {
  await loadScript();
  return new Promise((resolve, reject) => {
    let done = false;
    const finish = async () => { if (done) return; done = true; w.stop(); resolve(refresh ? await refresh() : { reconciled: true }); };
    const rz = new window.Razorpay({
      key: pay.key_id, order_id: pay.order_id, amount: pay.amount_paise, currency: "INR", name: "LaunchX360", description,
      image: `${window.location.origin}/logo.webp`, theme: { color: "#0B5D36" },
      prefill: { name: me.user.name, email: me.user.email, contact: me.user.phone || "" },
      handler: async (resp) => { if (done) return; done = true; w.stop(); try { resolve((await api.post(verifyPath, resp)).data); } catch (e) { reject(e); } },
      modal: { ondismiss: async () => { if (done) return; if ((await checkOnce(pay.id)) === "success") { finish(); } else { done = true; w.stop(); reject(new Error("Payment not completed. If money was deducted, it will be confirmed automatically within a few minutes.")); } } },
    });
    const w = watchPayment(rz, pay.id, finish);
    rz.on("payment.failed", (r) => { if (!done) { done = true; w.stop(); reject(new Error(r.error?.description || "Payment failed")); } });
    rz.open();
  });
}
